const Heart = () => (
  <>
    <path
      d="M11.9989 5.05297C11.1749 4.31896 10.0578 3.73095 8.83144 3.51671C7.37184 3.26172 5.75781 3.53959 4.3555 4.71744C3.421 5.50235 2.83641 6.73722 2.64269 8.07163C2.44735 9.41729 2.63758 10.9312 3.33356 12.3342C3.83708 13.3491 5.03578 14.626 6.2814 15.8013C7.55436 17.0024 8.97171 18.184 10.0089 19.0191C11.1621 19.9475 12.8357 19.9475 13.9888 19.0191C15.0261 18.184 16.4434 17.0024 17.7164 15.8013C18.962 14.626 20.1607 13.3492 20.6642 12.3342C21.3602 10.9312 21.5504 9.4173 21.3551 8.07164C21.1614 6.73723 20.5768 5.50237 19.6423 4.71745C18.24 3.5396 16.6259 3.26173 15.1663 3.51671C13.9399 3.73095 12.8229 4.31896 11.9989 5.05297Z"
      fill="#E53935"
    />
  </>
);

export default Heart;
